module.exports = __webpack_public_path__ + "static/media/card_5.a1ee7252.png";